import Immutable from 'immutable';
export default (props) => {
  const { userRole, $$data } = props;
  if ($$data === undefined) {
    console.warn('Missing $$data');
    return Immutable.fromJS([]);
  }
  if (userRole === undefined) {
    console.warn('Missing userRole');
    return Immutable.fromJS([]);
  }
  const $$subscriptions =
    userRole !== undefined && $$data !== undefined && $$data.get('myfutureevents') !== undefined
      ? $$data.get('myfutureevents').map((e) => e.get('id'))
      : Immutable.Map();
  return $$subscriptions;
};



// WEBPACK FOOTER //
// ./src/helpers/getMySubscriptions.jsx